// Brings a field into view once it has rendered, for both extraction surfaces.
//
// The field's tab may still be mounting, and once mounted may still be waiting
// on its data, so watch for it to appear rather than give up straight away.
// Returns the way to call the wait off — the reviewer may leave first.

const SCROLL_WAIT_LIMIT_MS = 2000;

const scrollTo = (field: HTMLElement) =>
  field.scrollIntoView({ behavior: 'smooth', block: 'center' });

export const scrollToFieldWhenRendered = (elementId: string): (() => void) => {
  const field = document.getElementById(elementId);

  if (field) {
    scrollTo(field);
    return () => undefined;
  }

  const observer = new MutationObserver(() => {
    const rendered = document.getElementById(elementId);
    if (!rendered) return;

    stopWaiting();
    scrollTo(rendered);
  });

  const giveUp = window.setTimeout(
    () => observer.disconnect(),
    SCROLL_WAIT_LIMIT_MS
  );

  const stopWaiting = () => {
    observer.disconnect();
    window.clearTimeout(giveUp);
  };

  observer.observe(document.body, { childList: true, subtree: true });

  return stopWaiting;
};
